import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "app/shared/_utils/services/base-crud-service";
import { QueryOperator } from "app/shared/_utils/services/query-operator.enum";
import { LazyLoadEvent } from "primeng/api";
import { PettyCashReturn } from "../entities/petty-cash-return";


@Injectable()
export class PettyCashReturnService extends BaseCrudService<PettyCashReturn> {

  public uri = '/api/pettyCashReturn/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance PettyCashAccountService');
  }

  buildSentence(entity?: PettyCashReturn, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.description ?
          `description${QueryOperator.Contain}${entity.description}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.identifier && entity.identifier.id) {
        query = query.concat(
          `identifier.id${QueryOperator.Equal}${entity.identifier.id}${QueryOperator.Split}`
        );
      }
      if (entity.vendor && entity.vendor.id) {
        query = query.concat(
          `vendor.id${QueryOperator.Equal}${entity.vendor.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.pettyCashAccount && entity.pettyCashAccount.id) {
        query = query.concat(
          `pettyCashAccount.id${QueryOperator.Equal}${entity.pettyCashAccount.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  } 

}



// WEBPACK FOOTER //
// ./src/app/core/services/petty-cash-return.service.ts